/**
 * Recovery-code handling for 2FA, shared by the sign-in screen and the
 * settings prompts so the two cannot drift apart.
 *
 * Format, confirmed by the backend:
 *   alphabet  0-9 and A-Z MINUS I, L, O and U — 32 symbols. Note 0 and 1
 *             ARE included; it is the letters that look like them that
 *             are not.
 *   shape     exactly 5 + 5 with one dash, e.g. 4H7QK-29MWR
 *
 * Be generous about what we accept. The server uppercases and strips
 * every non-alphanumeric before comparing, so a code pasted without its
 * dash, or with stray spaces, is the same code. This is the one screen
 * an admin reaches BECAUSE they have lost their phone — rejecting a
 * valid code here locks them out for good.
 */
const ALPHABET = /^[0-9A-HJ-KM-NP-TV-Z]{10}$/;

/** Strip punctuation and spacing, uppercase. Mirrors the server. */
export const normalizeRecoveryCode = (value: string): string =>
  value.toUpperCase().replace(/[^0-9A-Z]/g, '');

export const isRecoveryCode = (value: string): boolean =>
  ALPHABET.test(normalizeRecoveryCode(value));

/** What the user may type: the alphabet, plus the dash they expect. */
export const sanitizeRecoveryCodeInput = (value: string): string =>
  value
    .toUpperCase()
    .replace(/[^0-9A-Z-]/g, '')
    .slice(0, 11);

export const isTotpCode = (value: string): boolean => /^\d{6}$/.test(value);
